import roles from '../shared/userRoles.json'

const currency = (money) => {
  if (!money && money != '0') return ''

  return money.toLocaleString('es-CL', {
    style: 'currency',
    currency: 'CLP'
  })
}

const number = (number) => {
  if (!number && number != '0') return ''
  return number.toLocaleString('es-CL')
}

// Convención de dinero unificada de Plan2Sell:
// - Montos >= 1 millón se muestran en "MM" (en Chile MM = millones), redondeados,
//   con separador de miles chileno. Ej: $1.530 MM, $400 MM.
// - Montos < 1 millón se muestran en pesos completos. Ej: $850.000.
// Usar SIEMPRE este helper (o el filtro global `moneyMM`) en gráficos, tiles y textos
// agregados para no reintroducir los formatos ad-hoc ($1605.0M, $1605M, etc.).
const fmtMoneyMM = (value) => {
  if ((!value && value != '0') || isNaN(Number(value))) return ''
  const n = Number(value)
  if (Math.abs(n) >= 1e6) {
    return '$' + Math.round(n / 1e6).toLocaleString('es-CL') + ' MM'
  }
  return '$' + Math.round(n).toLocaleString('es-CL')
}

const planEstimation = (value, planType) => {
  if (planType === 'VENTAS' || planType === 'COSTOS') {
    return value.toLocaleString('es-CL', {
      style: 'currency',
      currency: 'CLP'
    })
  }
  
  if (planType === 'PRODUCCIÓN') {
    return value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, '.')
  }
  return value
}

const userRole = (value) => {
  const roleIndex = roles.findIndex(r => r.value === value)
  if (roleIndex === -1) {
    return '-'
  }

  return roles[roleIndex].text
}


const dateFormat = (value) => {
  const date = new Date(value)
  return date.toLocaleDateString('es-CL')
}

export default {
  currency,
  planEstimation,
  userRole,
  number,
  fmtMoneyMM,
  dateFormat
}

export { fmtMoneyMM }
